<template>
  <div id="league_playoffsVsMap">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="html_knockout_container" v-if="!noData">
      <div class="shareMenuArea">
        <MultipleChoiceSharingMenuRow
          v-if="themeItem"
          :list="MultipleChoiceSharingMenuRow_list"
          :baseOpt="MultipleChoiceSharingMenuRow_baseOpt"
          @clickMenuEvent="MultipleChoiceSharingMenuRow_clickMenuHandler"
          @clickPublicThemeEvent="
            MultipleChoiceSharingMenuRow_clickPublicThemeHandler
          "
        ></MultipleChoiceSharingMenuRow>
      </div>
      <HTML_KNOCKOUT_T8T12
        :datas="datas"
        :detailPathName="detailPathName"
      ></HTML_KNOCKOUT_T8T12>
    </div>
    <NO_DATA v-else className="relativePtb60"></NO_DATA>
  </div>
</template>
<script>
import {
  https_basketball_seasonList,
  https_getKnockoutData,
} from '@api/platfrom_basketball_api'

import NO_DATA from '@components/base/NO_DATA.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import HTML_KNOCKOUT_T8T12 from '@components/basketball/html/HTML_KNOCKOUT/teamsForT8OrT12.vue'
import MultipleChoiceSharingMenuRow from '@components/base/theme/multipleChoiceSharingMenuRow.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'league_playoffsVsMap',
  components: {
    HTML_KNOCKOUT_T8T12,
    marathon_select_opt,
    NO_DATA,
    MultipleChoiceSharingMenuRow,
  },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  data() {
    return {
      datas: null,
      seasonArr: [],
      currStageSeason: '',
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['seasonId', 'seasonName'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      detailPathName: 'teamDetailIndex',
      themeTemplateType: 27,
      findAnalysisItemParams: null,
      MultipleChoiceSharingMenuRow_baseOpt: {
        openMenuWidthVw: '22.2vw', // 打开的总宽度
        closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      },
      // MultipleChoiceSharingMenuRow_originBaseOpt: [
      //   {
      //     openMenuWidthVw: '11.1vw', // 打开的总宽度
      //     closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      //   },
      //   {
      //     openMenuWidthVw: '22.2vw', // 打开的总宽度
      //     closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      //   },
      //   {
      //     openMenuWidthVw: '33.3vw', // 打开的总宽度
      //     closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      //   },
      // ],
      MultipleChoiceSharingMenuRow_list: [
        {
          id: 'top12',
          name: '十二强晋级',
          isAct: false,
        },
        {
          id: 'top8',
          name: '八强晋级',
          isAct: false,
        },
      ],
    }
  },
  computed: {
    noData() {
      return (
        this.datas &&
        this.datas.data.dataList &&
        this.datas.data.dataList.length === 0
      )
    },
  },
  created() {
    // this.datas = {
    //   objectInfo: [],
    //   data: {
    //     dataType: 'top12',
    //     dataList: [
    //       {
    //         code: 10177,
    //         name: '12进8',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10177,
    //             stageName: '八分之一决赛',
    //             matchId: 101000,
    //             matchNum: 49,
    //             matchDate: '2022-12-03',
    //             matchDatetime: '2022-12-03T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1054,
    //             homeName: '荷兰',
    //             homeScore: 3,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1054.png',
    //             awayId: 1056,
    //             awayName: '美国',
    //             awayScore: 1,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1056.png',
    //             matchWinner: 'home',
    //             venueId: 1078,
    //             venueName: '哈里发国际体育场',
    //             winnerNextMatch: 101009,
    //             homeFlag: '1A',
    //             awayFlag: '2B',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10177,
    //             stageName: '八分之一决赛',
    //             matchId: 101001,
    //             matchNum: 50,
    //             matchDate: '2022-12-04',
    //             matchDatetime: '2022-12-04T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1020,
    //             homeName: '阿根廷',
    //             homeScore: 2,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             awayId: 1026,
    //             awayName: '澳大利亚',
    //             awayScore: 1,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1026.png',
    //             matchWinner: 'home',
    //             venueId: 1087,
    //             venueName: '艾哈迈德·本·阿里体育场',
    //             winnerNextMatch: 101009,
    //             homeFlag: '1C',
    //             awayFlag: '2D',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10177,
    //             stageName: '八分之一决赛',
    //             matchId: 101004,
    //             matchNum: 53,
    //             matchDate: '2022-12-05',
    //             matchDatetime: '2022-12-05T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1012,
    //             homeName: '日本',
    //             homeScore: 1,
    //             homePoint: 1,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1012.png',
    //             awayId: 1007,
    //             awayName: '克罗地亚',
    //             awayScore: 1,
    //             awayPoint: 3,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             matchWinner: 'away',
    //             venueId: 1084,
    //             venueName: '贾努布体育场',
    //             winnerNextMatch: 101008,
    //             homeFlag: '1E',
    //             awayFlag: '2F',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10177,
    //             stageName: '八分之一决赛',
    //             matchId: 101005,
    //             matchNum: 54,
    //             matchDate: '2022-12-06',
    //             matchDatetime: '2022-12-06T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1019,
    //             homeName: '巴西',
    //             homeScore: 4,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1019.png',
    //             awayId: 1001,
    //             awayName: '韩国',
    //             awayScore: 1,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1001.png',
    //             matchWinner: 'home',
    //             venueId: 1089,
    //             venueName: '974体育场',
    //             winnerNextMatch: 101008,
    //             homeFlag: '1G',
    //             awayFlag: '2H',
    //           },
    //         ],
    //       },
    //       {
    //         code: 10177,
    //         name: '8进4',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101009,
    //             matchNum: 57,
    //             matchDate: '2022-12-10',
    //             matchDatetime: '2022-12-10T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1054,
    //             homeName: '荷兰',
    //             homeScore: 2,
    //             homePoint: 3,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1054.png',
    //             awayId: 1020,
    //             awayName: '阿根廷',
    //             awayScore: 2,
    //             awayPoint: 4,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             matchWinner: 'away',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: 101012,
    //             homeFlag: 'W49',
    //             awayFlag: 'W50',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101008,
    //             matchNum: 58,
    //             matchDate: '2022-12-09',
    //             matchDatetime: '2022-12-09T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1007,
    //             homeName: '克罗地亚',
    //             homeScore: 1,
    //             homePoint: 4,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             awayId: 1019,
    //             awayName: '巴西',
    //             awayScore: 1,
    //             awayPoint: 2,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1019.png',
    //             matchWinner: 'home',
    //             venueId: 1085,
    //             venueName: '教育城体育场',
    //             winnerNextMatch: 101012,
    //             homeFlag: 'W53',
    //             awayFlag: 'W54',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101011,
    //             matchNum: 59,
    //             matchDate: '2022-12-11',
    //             matchDatetime: '2022-12-11T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1027,
    //             homeName: '英格兰',
    //             homeScore: 1,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1027.png',
    //             awayId: 1008,
    //             awayName: '法国',
    //             awayScore: 2,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             matchWinner: 'away',
    //             venueId: 1083,
    //             venueName: '巴伊特体育场',
    //             winnerNextMatch: 101013,
    //             homeFlag: 'W51',
    //             awayFlag: 'W52',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101010,
    //             matchNum: 60,
    //             matchDate: '2022-12-10',
    //             matchDatetime: '2022-12-10T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1023,
    //             homeName: '摩洛哥',
    //             homeScore: 1,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1023.png',
    //             awayId: 1015,
    //             awayName: '葡萄牙',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1015.png',
    //             matchWinner: 'home',
    //             venueId: 1086,
    //             venueName: '阿图玛玛体育场',
    //             winnerNextMatch: 101013,
    //             homeFlag: 'W55',
    //             awayFlag: 'W56',
    //           },
    //         ],
    //       },
    //       {
    //         code: 10179,
    //         name: '半决赛',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10179,
    //             stageName: '半决赛',
    //             matchId: 101012,
    //             matchNum: 61,
    //             matchDate: '2022-12-14',
    //             matchDatetime: '2022-12-14T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1020,
    //             homeName: '阿根廷',
    //             homeScore: 3,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             awayId: 1007,
    //             awayName: '克罗地亚',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             matchWinner: 'home',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: 101015,
    //             homeFlag: 'W57',
    //             awayFlag: 'W58',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10179,
    //             stageName: '半决赛',
    //             matchId: 101013,
    //             matchNum: 62,
    //             matchDate: '2022-12-15',
    //             matchDatetime: '2022-12-15T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1008,
    //             homeName: '法国',
    //             homeScore: 2,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             awayId: 1023,
    //             awayName: '摩洛哥',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1023.png',
    //             matchWinner: 'home',
    //             venueId: 1083,
    //             venueName: '巴伊特体育场',
    //             winnerNextMatch: 101015,
    //             homeFlag: 'W59',
    //             awayFlag: 'W60',
    //           },
    //         ],
    //       },
    //       {
    //         code: 10181,
    //         name: '决赛',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10181,
    //             stageName: '决赛',
    //             matchId: 101015,
    //             matchNum: 64,
    //             matchDate: '2022-12-18',
    //             matchDatetime: '2022-12-18T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1020,
    //             homeName: '阿根廷',
    //             homeScore: 3,
    //             homePoint: 4,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             awayId: 1008,
    //             awayName: '法国',
    //             awayScore: 3,
    //             awayPoint: 2,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             matchWinner: 'home',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: null,
    //             homeFlag: 'W61',
    //             awayFlag: 'W62',
    //           },
    //           // {
    //           //   competitionId: 109,
    //           //   seasonId: 1039,
    //           //   stageId: 10180,
    //           //   stageName: '季军赛',
    //           //   matchId: 101014,
    //           //   matchNum: 63,
    //           //   matchDate: '2022-12-17',
    //           //   matchDatetime: '2022-12-17T23:00:00',
    //           //   matchTime: '23:00:00',
    //           //   matchStatus: 'Played',
    //           //   homeId: 1007,
    //           //   homeName: '克罗地亚',
    //           //   homeScore: 2,
    //           //   homePoint: null,
    //           //   homeLogo:
    //           //     'https://images.mixtmt.com/hyper/football/team/1007.png',
    //           //   awayId: 1023,
    //           //   awayName: '摩洛哥',
    //           //   awayScore: 1,
    //           //   awayPoint: null,
    //           //   awayLogo:
    //           //     'https://images.mixtmt.com/hyper/football/team/1023.png',
    //           //   matchWinner: 'home',
    //           //   venueId: 1078,
    //           //   venueName: '哈里发国际体育场',
    //           //   winnerNextMatch: null,
    //           //   homeFlag: 'L61',
    //           //   awayFlag: 'L62',
    //           // },
    //         ],
    //       },
    //     ],

    //     // dataList: [],
    //   },
    //   statisticsModels: [],
    // }

    // this.datas = {
    //   objectInfo: [],
    //   data: {
    //     dataType: 'top8',
    //     dataList: [
    //       {
    //         code: 10177,
    //         name: '8进4',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101009,
    //             matchNum: 57,
    //             matchDate: '2022-12-10',
    //             matchDatetime: '2022-12-10T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1054,
    //             homeName: '荷兰',
    //             homeScore: 2,
    //             homePoint: 3,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1054.png',
    //             awayId: 1020,
    //             awayName: '阿根廷',
    //             awayScore: 2,
    //             awayPoint: 4,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             matchWinner: 'away',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: 101012,
    //             homeFlag: 'W49',
    //             awayFlag: 'W50',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101008,
    //             matchNum: 58,
    //             matchDate: '2022-12-09',
    //             matchDatetime: '2022-12-09T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1007,
    //             homeName: '克罗地亚',
    //             homeScore: 1,
    //             homePoint: 4,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             awayId: 1019,
    //             awayName: '巴西',
    //             awayScore: 1,
    //             awayPoint: 2,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1019.png',
    //             matchWinner: 'home',
    //             venueId: 1085,
    //             venueName: '教育城体育场',
    //             winnerNextMatch: 101012,
    //             homeFlag: 'W53',
    //             awayFlag: 'W54',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101011,
    //             matchNum: 59,
    //             matchDate: '2022-12-11',
    //             matchDatetime: '2022-12-11T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1027,
    //             homeName: '英格兰',
    //             homeScore: 1,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1027.png',
    //             awayId: 1008,
    //             awayName: '法国',
    //             awayScore: 2,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             matchWinner: 'away',
    //             venueId: 1083,
    //             venueName: '巴伊特体育场',
    //             winnerNextMatch: 101013,
    //             homeFlag: 'W51',
    //             awayFlag: 'W52',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10178,
    //             stageName: '四分之一决赛',
    //             matchId: 101010,
    //             matchNum: 60,
    //             matchDate: '2022-12-10',
    //             matchDatetime: '2022-12-10T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1023,
    //             homeName: '摩洛哥',
    //             homeScore: 1,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1023.png',
    //             awayId: 1015,
    //             awayName: '葡萄牙',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1015.png',
    //             matchWinner: 'home',
    //             venueId: 1086,
    //             venueName: '阿图玛玛体育场',
    //             winnerNextMatch: 101013,
    //             homeFlag: 'W55',
    //             awayFlag: 'W56',
    //           },
    //         ],
    //       },
    //       {
    //         code: 10179,
    //         name: '半决赛',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10179,
    //             stageName: '半决赛',
    //             matchId: 101012,
    //             matchNum: 61,
    //             matchDate: '2022-12-14',
    //             matchDatetime: '2022-12-14T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1020,
    //             homeName: '阿根廷',
    //             homeScore: 3,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             awayId: 1007,
    //             awayName: '克罗地亚',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             matchWinner: 'home',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: 101015,
    //             homeFlag: 'W57',
    //             awayFlag: 'W58',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10179,
    //             stageName: '半决赛',
    //             matchId: 101013,
    //             matchNum: 62,
    //             matchDate: '2022-12-15',
    //             matchDatetime: '2022-12-15T03:00:00',
    //             matchTime: '03:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1008,
    //             homeName: '法国',
    //             homeScore: 2,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             awayId: 1023,
    //             awayName: '摩洛哥',
    //             awayScore: 0,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1023.png',
    //             matchWinner: 'home',
    //             venueId: 1083,
    //             venueName: '巴伊特体育场',
    //             winnerNextMatch: 101015,
    //             homeFlag: 'W59',
    //             awayFlag: 'W60',
    //           },
    //         ],
    //       },
    //       {
    //         code: 10181,
    //         name: '决赛',
    //         matches: [
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10181,
    //             stageName: '决赛',
    //             matchId: 101015,
    //             matchNum: 64,
    //             matchDate: '2022-12-18',
    //             matchDatetime: '2022-12-18T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1020,
    //             homeName: '阿根廷',
    //             homeScore: 3,
    //             homePoint: 4,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1020.png',
    //             awayId: 1008,
    //             awayName: '法国',
    //             awayScore: 3,
    //             awayPoint: 2,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1008.png',
    //             matchWinner: 'home',
    //             venueId: 1088,
    //             venueName: '卢塞尔体育场',
    //             winnerNextMatch: null,
    //             homeFlag: 'W61',
    //             awayFlag: 'W62',
    //           },
    //           {
    //             competitionId: 109,
    //             seasonId: 1039,
    //             stageId: 10180,
    //             stageName: '季军赛',
    //             matchId: 101014,
    //             matchNum: 63,
    //             matchDate: '2022-12-17',
    //             matchDatetime: '2022-12-17T23:00:00',
    //             matchTime: '23:00:00',
    //             matchStatus: 'Played',
    //             homeId: 1007,
    //             homeName: '克罗地亚',
    //             homeScore: 2,
    //             homePoint: null,
    //             homeLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1007.png',
    //             awayId: 1023,
    //             awayName: '摩洛哥',
    //             awayScore: 1,
    //             awayPoint: null,
    //             awayLogo:
    //               'https://images.mixtmt.com/hyper/football/team/1023.png',
    //             matchWinner: 'home',
    //             venueId: 1078,
    //             venueName: '哈里发国际体育场',
    //             winnerNextMatch: null,
    //             homeFlag: 'L61',
    //             awayFlag: 'L62',
    //           },
    //         ],
    //       },
    //     ],
    //   },
    //   statisticsModels: [],
    // }
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.detailPathName = `teamDetailIndex_${moduleRouteNameEn}`
    }
    this.init()
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.dat
      await this.getSeasonList()
      await this.getKnockoutData()
      this.computedSelectOpt(this.selectOptData.configArr)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      this.findAnalysisItemParams = {
        sportType: 'basketball',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currStageSeason,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
      // let { num } = this.paramsChangeObj
      // this.paramsChangeObj = {
      //   type: 'reset',
      //   num: num + 1,
      // }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate, // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.makeAnalysisItemParams(this.themeTemplateType)
          await this.getKnockoutData()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    MultipleChoiceSharingMenuRow_clickMenuHandler(item) {
      this.MultipleChoiceSharingMenuRow_list.forEach((menuItem, meunIndex) => {
        if (item.id === menuItem.id) {
          menuItem.isAct = true
          this.themeItem = this.themeList[meunIndex]
        } else {
          menuItem.isAct = false
        }
      })
    },
    MultipleChoiceSharingMenuRow_clickPublicThemeHandler(item) {
      let themeItem = this.themeItem
      if (themeItem) {
        this.clickPublicTheme(themeItem)
      } else {
        console.error('没有找到对应分享的主题数据：themeItem')
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      let jsonArr = []
      let towTitleNameNumber = 0
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          if (this.seasonArr) {
            this.seasonArr.forEach((sidItem) => {
              if (sidItem.seasonId === item.seasonId) {
                item.analysisItemName = `${sidItem.seasonName}赛季${item.analysisItemName}`
              }
            })
          }
          return item
        })
        let MultipleChoiceSharingMenuRow_list = []
        // 重置分享按钮的名字
        this.themeList.forEach((shareItem) => {
          towTitleNameNumber += shareItem.twoTitle.length
          MultipleChoiceSharingMenuRow_list.push({
            id: shareItem.analysisItemId,
            name: shareItem.twoTitle,
            isAct: false,
          })
        })
        let themeList_length = this.themeList.length
        this.MultipleChoiceSharingMenuRow_list =
          MultipleChoiceSharingMenuRow_list
        // 不同的主题个数，分享按钮的长度不一样
        this.MultipleChoiceSharingMenuRow_baseOpt = {
          openMenuWidthVw: `${
            6.4 + 1.2 * towTitleNameNumber + themeList_length * (2.2 + 1.2)
          }vw`, // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        }
        // 选中最后一个分享按钮【高亮】
        this.MultipleChoiceSharingMenuRow_clickMenuHandler(
          this.MultipleChoiceSharingMenuRow_list[themeList_length - 1]
        )
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    async getSeasonList() {
      await https_basketball_seasonList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.seasonArr = res.data
            this.currStageSeason = this.seasonArr[0].seasonId
            this.makeAnalysisItemParams(this.themeTemplateType)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getKnockoutData() {
      await https_getKnockoutData(this.axiosBaseUrl, this.$axios, {
        sid: this.currStageSeason,
      })
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            let newData = []
            if (res.data && [3, 4].includes(res.data.length)) {
              newData = res.data
            }
            this.datas = {
              objectInfo: [],
              data: {
                dataList: newData,
              },
              statisticsModels: [],
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#league_playoffsVsMap {
  .select_area {
    padding-top: 1.388vw;
  }
  .html_knockout_container {
    width: 100%;
    padding: 0.694vw 0 2.788vw;
    .shareMenuArea {
      padding: 0.694vw 0 1.11vw;
      height: calc(2.2vw + 1px + 1px + 1.388vw);
    }
  }
}
</style>
